import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export enum RETRY_RESULTS {
  RETRY,
  STORE_OFFLINE,
  CANCEL
}

export interface RetryDialogData {
  message?: string;
}

@Component({
  selector: 'lfw-retry-dialog',
  templateUrl: './retry-dialog.component.html',
  styleUrls: ['./retry-dialog.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class RetryDialogComponent {
  dialogRef = inject(MatDialogRef<RetryDialogComponent>);
  data? = inject<RetryDialogData>(MAT_DIALOG_DATA);

  RETRY_RESULTS = RETRY_RESULTS;
}
